import { DELETE_CUSTOM_CLAIM_SUCCESS } from 'actions'
import { DeleteCustomClaimSuccessAction } from './types/DeleteCustomClaimSuccessAction'

export const createDeleteCustomClaimSuccessAction = (): DeleteCustomClaimSuccessAction => {
  return {
    type: DELETE_CUSTOM_CLAIM_SUCCESS,
  }
}
